<template>
	<div class="login">
		<!-- 中间卡片 box -->
		<div class="login-wrap" :class="{ 'login-wrap-left': isLeft, 'login-wrap-right': isRight }">
			<!-- 左侧图片 -->
			<div class="login-left-wrap"></div>
			<!-- 右侧 -->
			<div class="login-right-wrap">
				<div class="login-type">
					<h2 class="login-welcome">欢迎登陆</h2>
					<el-form :model="userForm" :rules="rules" ref="userForm" class="demo-ruleForm" label-width="0">
						<el-form-item prop="username">
							<el-input prefix-icon="el-icon-user-solid" v-model="userForm.username" placeholder="请输入用户名">
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input prefix-icon="el-icon-lock" type="password" v-model="userForm.password"
								placeholder="请输入密码"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button class="btn-item" @click="submitForm('userForm')">登录</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	setAuthorization,
	setAuthorizationDH,
	setAuthorizationDHUserId,
	setAuthorizationAdmin,
} from "@/utils/request"; //旧版大华 后续删除 切换新版重新对接
import {
	mapActions
} from 'vuex'
export default {
	name: '',
	data() {
		return {
			userForm: {
				username: '13033331155',
				password: '12345678',
			},
			isLeft: false,
			isRight: false,
			rules: {
				username: [{
					required: true,
					message: '请填写用户名',
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: '请填写密码',
					trigger: 'blur'
				}]
			}
		}
	},
	beforeCreate() { },

	created() {
	},
	mounted() {
		window.addEventListener('keyup', this.handleKeyup)
	},
	// 销毁后
	destroyed() {
		// 移除监听
		window.removeEventListener('keyup', this.handleKeyup)
	},
	methods: {
		...mapActions([
			'handleLogin'
		]),
		// 键盘事件
		handleKeyup(event) {
			const e = event || window.event || arguments.callee.caller.arguments[0]
			if (!e) return
			const {
				key,
				keyCode
			} = e
			if (key == 'Enter') {
				this.submitForm('userForm')
			}
		},
		// 登录
		submitForm(formName) {
			// localStorage.setItem("checkEmergencyF", 0)
			// localStorage.setItem("checkEmergencyZ", 0)
			// this.$message({
			//   type: 'success',
			//   message: '登录成功!'
			// })
			// this.$router.replace({
			//    path: '/home'
			// })
			// return



			let _this = this
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const name = _this.userForm.username.split("").reverse().join("") //反转
					const namend = _this.$md5(`[${_this.userForm.password}]{[${name}]}`)
					const NAMEND = namend.toUpperCase()
					const params = {
						username: _this.userForm.username,
						password: NAMEND
					}
					this.handleLogin(params).then(res => {
						window.sessionStorage.setItem('token', this.formName)
						localStorage.setItem("checkEmergencyF", 0)
						localStorage.setItem("checkEmergencyZ", 0)

						this.$message({
							message: res || '登录成功！',
							type: 'success'
						})
	
						this.$router.push({
							path: '/home'
						})
						setAuthorization({
							token: localStorage.getItem("token"),
						});

						setAuthorizationAdmin({
							synchronizationStatus: 1, //是否管理员权限
						});
						// 登陆大华
						_this.$api.loginDH().then(this.afterLoginDH);
						//旧版大华 后续删除 切换新版重新对接
						//获取大户地址信息
						_this.$api.dhConfig().then((res) => {
							console.log(res, 145)
							if (res.code * 1 == 200) {
								localStorage.setItem("defaultConfigProtocol", res.body.protocol),
									localStorage.setItem("defaultConfigLoginIp", res.body
										.ip); // DEMO采用登陆页面的地址,   若第三方自行开发，请填写大华服务器对应的IP
								localStorage.setItem("defaultConfigPort", res.body
									.port), //  DEMO采用登陆页面的映射端口,若第三方自行开发，请填写大华服务器对应的端口
									localStorage.setItem("defaultConfigCredential", this.userForm
										.username);
							}
						}).catch((err) => {
							console.log("请求大华网址报错了", err);
						});

					}).catch(err => {
						console.log(err);
						this.$message({
							message: err || '登录失败！',
							type: 'error'
						})
					})

				}
			})
		},

		// 初始化地图中心位置
		async initMapCenter() {
			let obj = {
				type: 'index_base'
			}
			let res = await this.$api.getCycleOptionsAPI(obj)
			if (res.resultCode == 200) {
				let center = [
					res.resultData[0].code * 1, res.resultData[0].name * 1
				]
				let zoom = res.resultData[0].sort
				localStorage.setItem('center', JSON.stringify(center))
				localStorage.setItem('zoom', zoom)
			}
			let obj1 = {
				type: 'base_unit'
			}
			let res1 = await this.$api.getCycleOptionsAPI(obj1)
			if (res1.resultCode == 200) {
				let code = res1.resultData[0].code
				localStorage.setItem('code', code)
			}

		},

		//旧版大华 后续删除 切换新版重新对接 
		// 登陆大华系统
		afterLoginDH(res) {
			console.log(res, "大华返回的信息");
			if (res.code == 200) {
				if (res.body.code) {
					this.$notify({
						title: "大华登录失败",
						message: res.body.message,
						type: "warning",
					});
					return;
				} else {
					let dh = false;
					this.DHlogin(dh);
					this.$notify({
						title: "成功",
						message: "大华登录成功",
						type: "success",
					});
				}
				setAuthorizationDH({
					token: res.body.token,
				});
				setAuthorizationDHUserId({
					userId: res.body.userId,
				});
			} else {
				let dh = true;
				this.DHlogin(dh);
				this.$notify({
					title: "警告",
					message: res.cnMsg,
					type: "warning",
				});
			}
		},
		DHlogin(Config) {
			localStorage.setItem('dh', Config)
		}


	}
}
</script>

<style lang="scss" scoped>
.login {
	height: 100vh;
	position: relative;
	display: flex;
	background: url('../../assets/login-bg.jpg') no-repeat center center;
	-webkit-background-size: cover;
	background-size: cover;
}

.login-wrap-left {
	left: 30% !important;
}

.login-wrap-right {
	left: 70% !important;
}

.login-wrap {
	width: 800px;
	height: 400px;
	background-color: #fff;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);

	.login-left-wrap {
		height: 100%;
		width: 450px;
		background: url('../../assets/login-wrap-bg.png') no-repeat center center;
		-webkit-background-size: cover;
		background-size: cover;
		color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		transition: all 0.5s;

		.left-text {
			font-size: 30px;
			margin-top: 20px;
		}
	}

	.login-right-wrap {
		width: 350px;
		height: 100%;
		text-align: center;
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		/*align-items: center;*/
		justify-content: center;
		position: absolute;
		left: 450px;
		top: 0;
		background-color: #fff;
		transition: all 0.5s;

		.login-welcome {
			margin-bottom: 40px;
			font-weight: 400;
		}

		.login-title {
			width: 60px;
			height: 60px;
			background-color: #fff;
			display: flex;
			justify-content: center;
			align-items: center;
			letter-spacing: 1px;
			font-weight: 400;
			color: #fff;
			margin: 0 auto 15px auto;

			>img {
				width: 40px;
				height: 40px;
			}
		}

		.btn-item {
			width: 100%;
			background-color: #133950;
			color: #fff;
			letter-spacing: 5px;
			margin-top: 20px;
			border: none;
		}
	}
}
</style>
